import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
import {Me} from "../api-customers/Me";

@Injectable({ providedIn: 'root' })
export class EdgeService {
  private baseRef: string = environment.origin;

  constructor(
    private http: HttpClient
  ) { }

  public me(): Observable<Me> {
    return this.http.get<Me>(`${this.baseRef}/me`);
  }

}
